import { FuelFlex } from '@frete.com/fuel-station-react';
import React, { FC } from 'react';
import ChatNotificationButton from 'externals/ChatNotificationButton';
import PhoneButton from './PhoneButton';
import { CreateRiskSearch } from './RiskManagement';
import WhatsAppButton from './WhatsAppButton';
import { IMenuProps } from './types';

const Menu: FC<IMenuProps> = ({ isPaidFee, showChatButton, truckerUuid, truckerName, freightId }) => (
  <FuelFlex defaultProps={{ gap: 'km2' }}>
    {showChatButton ? (
      <ChatNotificationButton
        source="trucker-profile"
        truckerUuid={truckerUuid}
        truckerName={truckerName}
        freightId={freightId}
        withBorder
      />
    ) : (
      <>
        <WhatsAppButton />
        <PhoneButton />
      </>
    )}
    <CreateRiskSearch buttonSize="small" variant="secondary" isPaidFee={isPaidFee} />
  </FuelFlex>
);

export default Menu;
